import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { LabOSTopbar } from './lib/labos';
import Home from './pages/Home';
import Dashboard from './pages/Dashboard';
import Admin from './pages/Admin';
import { Toaster } from '@/components/ui/sonner';
import { useDarkMode } from './hooks/useDarkMode';

function App() {
  // Initialize dark mode at app level to ensure proper background colors
  useDarkMode();

  return (
    <BrowserRouter>
      <div className="flex flex-col h-screen">
        <LabOSTopbar appName="AICS Workflows Designer" accentColor="#8b5cf6" />
        <main className="flex-1 overflow-auto">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
        <Toaster />
      </div>
    </BrowserRouter>
  );
}

export default App;
